import { Navigate, useParams } from "react-router-dom";
import Breadcrumbs from "../components/shared/Breadcrumbs";
import Seo from "../components/shared/Seo";
import Badge from "../components/ui/Badge";
import LoadingState from "../components/ui/LoadingState";
import NoticeBanner from "../components/ui/NoticeBanner";
import SectionHeading from "../components/ui/SectionHeading";
import { useSiteData } from "../app/SiteDataContext";
import useContentResource from "../hooks/useContentResource";
import { createArticleSchema, createBreadcrumbSchema } from "../seo/schema";
import { buildCanonicalUrl } from "../seo/siteConfig";
import { getBlogPostBySlug } from "../services/content/blog.service";

function BlogDetailPage() {
  const { settings } = useSiteData();
  const siteProfile = settings.siteProfile;
  const { slug } = useParams();
  const postState = useContentResource(
    ({ signal }) => getBlogPostBySlug(slug, { signal }),
    [slug]
  );
  const post = postState.data;

  if (postState.loading) {
    return <LoadingState title="Yazi detayi yukleniyor..." />;
  }

  if (!post) {
    return <Navigate replace to="/blog" />;
  }

  return (
    <div className="page-stack">
      <Seo
        title={post.title}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        type="article"
        keywords={[post.category, ...post.tags]}
        schema={[
          createArticleSchema(post, siteProfile.name),
          createBreadcrumbSchema([
            { name: "Anasayfa", url: buildCanonicalUrl("/") },
            { name: "Blog", url: buildCanonicalUrl("/blog") },
            { name: post.title, url: buildCanonicalUrl(`/blog/${post.slug}`) },
          ]),
        ]}
      />
      {postState.usedFallback ? (
        <NoticeBanner>
          Bu yazi local fallback verisiyle gosteriliyor. WordPress baglantisi
          geldiginde ayni detay ekrani API verisiyle calisacak.
        </NoticeBanner>
      ) : null}
      <section className="glass-panel page-hero">
        <Breadcrumbs
          items={[
            { name: "Anasayfa", path: "/" },
            { name: "Blog", path: "/blog" },
            { name: post.title, path: `/blog/${post.slug}` },
          ]}
        />
        <div className="meta-row">
          <Badge>{post.category}</Badge>
          <span className="meta-text">{post.readingTime}</span>
          <span className="meta-text">
            {new Date(post.publishedAt).toLocaleDateString("tr-TR")}
          </span>
        </div>
        <SectionHeading title={post.title} description={post.excerpt} />
      </section>

      <article className="glass-panel article-panel">
        <div className="featured-story-art article-cover">
          {post.coverImage ? (
            <img
              className="card-media-image"
              src={post.coverImage}
              alt={post.cover || post.title}
              loading="lazy"
            />
          ) : (
            post.cover
          )}
        </div>
        <p>{post.content}</p>
      </article>
    </div>
  );
}

export default BlogDetailPage;
